export default __webpack_public_path__ + "static/media/04.a6f8175f.jpg";